import { useEffect, useRef } from 'react';

import { useConfluenceAnalyticsEvents } from '@confluence/analytics/entry-points/useConfluenceAnalyticsEvents.ts';

import { EXTENSION_KEY, EXTENSION_TYPE } from '../nativeTabsConstants.ts';

type NativeTabsAnalyticsMode = 'editor' | 'renderer';

type UseViewedAnalyticsProps = {
	mode: NativeTabsAnalyticsMode;
};

const sourceByMode: Record<NativeTabsAnalyticsMode, string> = {
	editor: 'editPageScreen',
	renderer: 'viewPageScreen',
};

export const useViewedAnalytics = ({ mode }: UseViewedAnalyticsProps): void => {
	const { createEvent } = useConfluenceAnalyticsEvents();
	const hasFiredRef = useRef(false);

	useEffect(() => {
		if (hasFiredRef.current) {
			return;
		}

		createEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'viewed',
				actionSubject: 'macro',
				actionSubjectId: EXTENSION_KEY,
				source: sourceByMode[mode],
				attributes: {
					extensionType: EXTENSION_TYPE,
				},
			},
		}).fire();
		hasFiredRef.current = true;
	}, [createEvent, mode]);
};
